import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';

/** document hooks */
interface IErrorLog {
	err: Error;
	vm: any;
	info: string;
	url: string;
}

/** document hooks */
export interface IErrorLogState {
	logs: IErrorLog[];
}

/** document hooks */
@Module({
	dynamic: true,
	store,
	name: 'errorLog'
})
class ErrorLog extends VuexModule implements IErrorLogState {
	public logs: IErrorLog[] = [];

	/** document hooks */
	@Mutation
	private ADD_ERROR_LOG(log: IErrorLog): any {
		this.logs.push(log);
	}

	/** document hooks */
	@Mutation
	private CLEAR_ERROR_LOG(): any {
		this.logs.splice(0);
	}

	/** document hooks */
	@Action
	public AddErrorLog(log: IErrorLog): any {
		this.ADD_ERROR_LOG(log);
	}

	/** document hooks */
	@Action
	public ClearErrorLog(): any {
		this.CLEAR_ERROR_LOG();
	}
}

/** document hooks */
export const errorLogModule: any = getModule(ErrorLog);
